import { getAdvancedMdConfig } from "@/configuration/ehr/advancedmd";
import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { isValerieMockEhrGroup } from "@/src/lib/ehr/ehr-config";
import { type Group } from "@/src/models/group";

/**
 * Whether editing a patient changes its EHR chart by chart number (MRN): the patient card's ID field edits the MRN,
 * and saving it links the chart the EHR finds for that MRN (getPatientByMrn). AdvancedMD's chart number and InSync's
 * MRN (FCC) are the IDs staff know a chart by. The card and the save action both read this, so they always agree.
 */
export function editsPatientChartNumber(group: Group): boolean {
  if (isValerieMockEhrGroup(group)) return false;

  return getAdvancedMdConfig(group) !== null || getGroupConfigSubdomain(group) === ConfigSubdomain.FCC;
}
